import React from 'react';
import {
  Routes, Route,
} from 'react-router-dom';
import PageDashboard from '../pages/game/PageDashboard';
import PageStageDifficulties from '../pages/game/PageStageDifficulties';
import PageStageQSets from '../pages/game/PageStageQSets';
import PageAnswer from '../pages/game/PageAnswer';
import PageRankings from '../pages/game/PageRankings';
import PageProfile from '../pages/game/PageProfile';
import PageResult from '../pages/game/PageResult';
import PageRankingRules from '../pages/game/PageRankingRules';
import PageProfileMascot from '../pages/game/PageProfileMascot';

const RoutesGame = () => (
  <Routes>
    <Route path="" element={<PageDashboard />} />
    <Route
      path="/stages/:stage"
      element={<PageStageDifficulties />}
    />
    <Route
      path="/stages/:stage/:difficulty"
      element={<PageStageQSets />}
    />
    <Route
      path="/stages/:stage/:difficulty/:refCode"
      element={<PageAnswer />}
    />
    <Route
      path="/stages/:stage/:difficulty/:refCode/result"
      element={<PageResult />}
    />
    <Route path="/rankings" element={<PageRankings />} />
    <Route path="/rankings/rules" element={<PageRankingRules />} />
    <Route path="/profile" element={<PageProfile />} />
    <Route path="/profile/mascot" element={<PageProfileMascot />} />
  </Routes>
);

export default RoutesGame;
